module.exports = __webpack_public_path__ + "static/media/christmas-tree-1-min.72edea16.jpg";